import React from 'react';
import { colors } from '@/shared/tokens/colors';
import { CardDefault } from '@spark';
import MatrixCard from './MatrixCard';

function formatMetrics(confusionMatrix, key) {
    return {
        truePositive: confusionMatrix.tp[key],
        falsePositive: confusionMatrix.fp[key],
        falseNegative: confusionMatrix.fn[key],
        trueNegative: confusionMatrix.tn[key],
    };
}

const ErrorAnalysis = ({
    confusionMatrix,
    showComparison,
    oldModel,
    teacherModelProcessing,
    studentModelProcessing,
    compareWith,
    currentVersion,
    accuracy,
}) => {
    const isTeacherComparison = compareWith === 'oldModel';
    const comparisonName = oldModel;
    const currentName = `SpecificAI ${currentVersion}`;
    const comparisonColor = isTeacherComparison ? colors.orange : '#8395a7';

    const showComparisonProcessing = teacherModelProcessing && isTeacherComparison;
    const showCurrentProcessing = studentModelProcessing;

    const currentModelConfusionMatrix = formatMetrics(confusionMatrix, 'newModel');
    const comparisonModelConfusionMatrix = formatMetrics(confusionMatrix, 'oldModel');

    return (
        <CardDefault
            type="collapsed"
            open={false}
            title="Error Analysis"
            subtitle="Where the model is right and where it makes mistakes"
            showSubtitle={true}
            border="yes"
            fullWidth
            className="fs-unmask"
        >
            <div style={{ display: 'flex', gap: 16, alignItems: 'stretch', flexWrap: 'wrap' }}>
                {showComparison && (
                    <MatrixCard
                        title={comparisonName}
                        data={comparisonModelConfusionMatrix}
                        isProcessing={showComparisonProcessing}
                        modelType={isTeacherComparison ? 'teacher' : 'optune'}
                        color={comparisonColor}
                        accuracyMetric={accuracy?.oldModel}
                    />
                )}
                <MatrixCard
                    title={showComparison ? currentName : null}
                    data={currentModelConfusionMatrix}
                    isProcessing={showCurrentProcessing}
                    modelType="optune"
                    color={colors.buttonsBlue}
                    accuracyMetric={accuracy?.newModel}
                />
            </div>
        </CardDefault>
    );
};

export default ErrorAnalysis;
